import type { FC } from 'react';

interface MessageIconProps {
  count?: number;
}

const MessageIcon: FC<MessageIconProps> = ({ count = 0 }) => {
  const hasUnread = count > 0;

  return (
    <svg width="24" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.75 0C1.2332 0 0 1.2332 0 2.75V15.125C0 16.6418 1.2332 17.875 2.75 17.875H6.875V21.3125C6.875 21.5746 7.02109 21.8109 7.25313 21.927C7.48516 22.043 7.76445 22.0172 7.975 21.8625L13.2902 17.875H19.25C20.7668 17.875 22 16.6418 22 15.125V2.75C22 1.2332 20.7668 0 19.25 0H2.75Z"
        fill={hasUnread ? '#1C2DEF' : '#ffffff'}
        stroke={hasUnread ? 'none' : 'black'}
        strokeWidth={hasUnread ? '0' : '1.5'}
      />
      {hasUnread && (
        <text
          x="11"
          y="10"
          textAnchor="middle"
          dominantBaseline="middle"
          fill="white"
          fontSize="12"
          fontWeight="bold"
          fontFamily="system-ui, -apple-system, sans-serif"
        >
          {count > 99 ? '99+' : count}
        </text>
      )}
    </svg>
  );
};

export default MessageIcon;
